/**
 * Class Commons
 *s
 * @author Jeremie Nogues
 * @year 2024
 * @filename commons.js
 * @location /js/my
 */

import selectize from "selectize";
export default class Commons {
	/**
	 * Constructor
	 */
	constructor(appContext) {
		this.appContext = appContext;
		this.objDialog = this.appContext.get("objDialog");

		this.fadeEffect = null;
		this.currentTva = null;
	}
	/*
	 * Vérifie la version du navigateur
	 */
	checkNavigator() {

		//si les cookies sont pas autorisés
		if (!navigator.cookieEnabled) {

			//id du dialog
			const id_dialog = "dialog_navigateur";
			this.objDialog.setId(id_dialog);

			//si le dialog n'existe pas
			if (!document.getElementById(id_dialog)) {

				//création du dialog
				this.objDialog.create("Activation des cookies requise", false);

				//message d'alerte
				const span = document.createElement("span");
				let html = "<b>Afin de profiter pleinement de notre plateforme, vous devez activer les cookies sur votre navigateur.</b><br>";
				html = html + "<br>Si vous rencontrez des difficultés, vous pouvez nous contacter à l'adresse suivante : <a href='mailto:contact-tacit@univ-rennes2.fr'>contact-tacit@univ-rennes2.fr</a>.";
				span.innerHTML = html;
				this.objDialog.updateContent(span);
			}

			//cache la croix
			this.objDialog.hideClose();

			//affiche la background opaque
			document.querySelectorAll(".dialog").forEach(element => {
				element.style.backgroundColor = "#e5e5e5";
			});

			//ouvre le dialog
			this.objDialog.show();
		} else {
			const userAgent = navigator.userAgent.toLowerCase();

			// Détection des navigateurs
			const isFirefox = userAgent.includes("firefox");
			const isIE = userAgent.includes("trident");

			// Récupération des versions
			const firefoxVersion = isFirefox ? this.getBrowserVersion("firefox") : Infinity;
			const ieVersion = isIE ? this.getBrowserVersion("msie") : Infinity;

			//si les versions sont obsolètes
			if (firefoxVersion < 10 || ieVersion < 9) {

				//id du dialog
				const id_dialog = "dialog_navigateur";
				this.objDialog.setId(id_dialog);

				//si le dialog n'existe pas
				if (!document.getElementById(id_dialog)) {

					//création du dialog
					this.objDialog.create("Mise à jour du navigateur requise", false);

					//message d'alerte
					const span = document.createElement("span");
					let html = "<b>Afin de profiter pleinement de notre plateforme, vous devez mettre à jour votre navigateur.</b><br><br>";
					if (isFirefox) {
						html = html + "<div><a href='http://www.mozilla.org/fr/firefox/new/' target='_blank'>Mozilla Firefox (version 10 minimum)</a></div>";
					} else {
						html = html + "<div><a href='https://support.microsoft.com/en-us/help/17621' target='_blank'>Internet Explorer (version 9 minimum)</a></div>";
					}
					html = html + "<br>Si vous rencontrez des difficultés, vous pouvez nous contacter à l'adresse suivante : <a href='mailto:contact-tacit@univ-rennes2.fr'>contact-tacit@univ-rennes2.fr</a>.";
					span.innerHTML = html;
					this.objDialog.updateContent(span);
				}

				//cache la croix
				this.objDialog.hideClose();

				//affiche la background opaque
				document.querySelectorAll(".dialog").forEach(element => {
					element.style.backgroundColor = "#e5e5e5";
				});

				//ouvre le dialog
				this.objDialog.show();
			}
		}
	}
	/*
	 * Récupère la version d'un navigateur spécifique
	 */
	getBrowserVersion(browserName) {
		const ua = navigator.userAgent.toLowerCase();
		if (browserName === 'firefox') {
			const match = ua.match(/firefox\/(\d+)/);
			if (match) {
				return parseInt(match[1], 10);
			} else {
				return 0;
			}
		}
		if (browserName === 'msie') {
			// IE 10 et inférieurs : "MSIE X.X"
			const match = ua.match(/msie (\d+)/);
			if (match) {
				return parseInt(match[1], 10);
			}

			// IE 11 : "rv:11.0" et "trident"
			const trident = ua.includes("trident");
			const rvMatch = ua.match(/rv:(\d+)/);
			if (trident && rvMatch) {
				return parseInt(rvMatch[1], 10);
			} else {
				return 0;
			}
		}
		return 0;
	}
	/*
	 * regarde si le meme compte a été connecté ailleurs
	 */
	checkAilleurs() {
		$.getJSON(php_to_js_vars.url + "logout/checkAilleurs", (data) => {
			if (data.message === "true") {
				location.href = php_to_js_vars.url + "connexion/ailleurs";
			}
		});
	}
	/*
	 * Création d'un tooltip
	 */
	createTooltip(element) {

		// Création du tooltip
		const tooltip = document.createElement("div");
		tooltip.classList.add("tooltip");
		tooltip.innerHTML = element.getAttribute("tooltip-content");

		// Création de la flèche
		const fleche = document.createElement("div");
		fleche.classList.add("tooltip-fleche");

		// Fonction pour rafraîchir le contenu du tooltip
		element.refreshTooltipContent = (newContent) => {
			tooltip.innerHTML = newContent;
		};

		// Fonction pour supprimer le tooltip proprement
		function removeTooltip() {
			tooltip.remove();
			fleche.remove();
		}

		//mousenter sur l'élement
		element.addEventListener("mouseenter", (event) => {

			// Position de l'élément
			const viewportWidth = document.documentElement.clientWidth;
			const elementRect = event.currentTarget.getBoundingClientRect();
			const scrollY = window.scrollY || window.pageYOffset;

			// Ajoute le tooltip au DOM
			document.body.appendChild(tooltip);
			document.body.appendChild(fleche);

			// Position horizontale (centrée)
			const tooltip_left = elementRect.left + elementRect.width / 2;
			tooltip.style.left = tooltip_left - tooltip.offsetWidth / 2 + "px";
			fleche.style.left = tooltip_left - 5 + "px";

			// Position verticale par défaut : AU-DESSUS
			let tooltip_top = elementRect.top + scrollY - tooltip.offsetHeight - 12;
			let fleche_top = (tooltip_top - 1) + tooltip.offsetHeight;

			// Si le tooltip dépasse en haut, l'afficher EN DESSOUS
			if (tooltip_top < scrollY) {
				tooltip_top = elementRect.bottom + scrollY + 12;
				fleche_top = tooltip_top - 7; // ajuster pour placer la flèche au-dessus du tooltip
				fleche.style.clipPath = "polygon(50% 0%, 0% 100%, 100% 100%)"; // flèche vers le haut
			} else {
				fleche.style.clipPath = "polygon(0 0, 100% 0, 50% 100%)"; // flèche vers le bas
			}

			tooltip.style.top = tooltip_top + "px";
			fleche.style.top = fleche_top + "px";

			// Vérifie si le tooltip dépasse à gauche ou à droite
			const leftAsInteger = parseInt(tooltip.style.left, 10);
			if (leftAsInteger + tooltip.offsetWidth > viewportWidth) {
				tooltip.style.left = viewportWidth - tooltip.offsetWidth - 5 + "px";
			} else if (leftAsInteger < 0) {
				tooltip.style.left = "5px";
			}
		});

		// Cache au mouseleave
		element.addEventListener("mouseleave", removeTooltip);

		// Trouver le parent <tr>
		const parentRow = element.closest("tr");
		if (parentRow) {

			// Surveille la suppression du <tr> parent
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.removedNodes.forEach((removedNode) => {
						if (removedNode === parentRow) {
							removeTooltip();
							observer.disconnect(); // Arrête d'observer après suppression
						}
					});
				});
			});

			// Observe les modifications du parent du <tr>
			if (parentRow.parentNode) {
				observer.observe(parentRow.parentNode, {childList: true});
			}
		}
	}
	/**
	 * Affiche / cache un élément
	 * 
	 * @param {string} id -> id de l'élément
	 * @param {string} display -> display value
	 */
	setDisplay(id, display) {
		const el = document.getElementById(id);
		if (el) {
			el.style.display = display;
		}
	}
	/**
	 * Check / uncheck un élément
	 * 
	 * @param {string} id -> id de l'élément
	 * @param {string} checked -> checked value
	 */
	setChecked(id, checked) {
		const el = document.getElementById(id);
		if (el) {
			el.checked = checked;
		}
	}
	/**
	 * Disable / enable un élément
	 * 
	 * @param {string} id -> id de l'élément
	 * @param {string} disabled -> disabled value
	 */
	setDisabled(id, disabled) {
		const el = document.getElementById(id);
		if (el) {
			el.disabled = disabled;
		}
	}
	/**
	 * Enregistre le cookie de choix
	 * 
	 * @param {string} value -> valeur du cookie
	 * @param {string} href -> redirection
	 */
	saveCookie(value, href) {
		document.cookie = "remember_me_choix=" + value;
		location.href = php_to_js_vars.url + href;
	}
	/**
	 * Récupère le contenu d'un cookie
	 * 
	 * @param {string} name -> valeur du cookie
	 */
	getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) {
			return parts.pop().split(";").shift();
		} else {
			return "";
		}
	}
	/**
	 * Désactive un bouton js
	 * 
	 * @param {string} id -> id du bouton à désactiver
	 */
	disableButton(id) {
		const bouton = document.getElementById(id);
		const html = bouton.innerHTML.split("</span>");
		bouton.innerHTML = "<span class='icone-wait'></span>" + html[1];
		bouton.disabled = true;
	}
	/**
	 * Active un bouton js
	 * 
	 * @param {string} id -> id du bouton à activer
	 * @param {string} iconClass -> class à appliquer au bouton
	 */
	enableButton(id, iconClass) {
		const bouton = document.getElementById(id);
		const html = bouton.innerHTML.split("</span>");
		bouton.innerHTML = "<span class='" + iconClass + "'></span>" + html[1];
		bouton.disabled = false;
	}
	/**
	 * Toggle l'icone valider sur un bouton
	 * 
	 * @param {string} id -> id du bouton
	 * @param {string} icone -> icone à afficher
	 */
	toggleButton(id, icone = "valide") {
		this.bindEvent(id, "click", (event) => {
			const span = event.currentTarget.querySelector("span");
			span.classList.toggle("icone-" + icone);
		});
	}
	/**
	 * Bind un event si l'élément existe
	 * 
	 * @param {string} id -> id de l'élément
	 * @param {event} event -> type d'event
	 * @param {function} handler -> fonction à binder
	 */
	bindEvent(id, event, handler) {
		const el = document.getElementById(id);
		if (el) {
			el.addEventListener(event, handler);
		}
	}
	/**
	 * Affiche un message d'erreur dans un formulaire
	 * 
	 * @param {string} id -> id de la div d'erreur
	 * @param {string} html -> contenu du message
	 * @param {string} couleur -> couleur du message
	 */
	showFormError(id, html, couleur = "orange", fadeout = true) {

		//élément concerné
		const element = document.getElementById(id);

		//supprime les couleurs s'il y a déjà
		element.classList.remove("orange", "bleu", "vert", "rouge");

		//icone en fonction de la couleur
		let icone = "";
		switch (couleur) {
			case "bleu":
				icone = "aides";
				break;
			case "orange":
				icone = "warning";
				break;
			case "vert":
				icone = "valide";
				break;
			case "rouge":
				icone = "delete";
				//force le texte en bleu
				couleur = "bleu";
				break;
		}

		//affiche l'erreur dans la div
		element.innerHTML = "<div class='icone-" + icone + "'></div>&nbsp;&nbsp;" + html;
		element.classList.add(couleur);
		element.style.display = "block";
		element.style.opacity = 1;

		//cache au bout de 8 secondes
		if (fadeout) {
			this.fadeOut(element);
	}
	}
	/**
	 * Affiche un message d'erreur dans une div
	 * 
	 * @param {string} html -> contenu du message
	 */
	showDivError(html) {

		//div avec message d'erreur
		const div = document.createElement("div");
		div.className = "message-erreur";
		div.innerHTML = "<div class='icone-warning'></div> &nbsp;" + html;
		document.body.appendChild(div);

		//cache le message au bout de 8 secondes
		this.fadeOut(div);
	}
	/**
	 * Simule un event
	 * 
	 * @param {object} elem -> element sélectionné
	 * @param {string} type -> type d'event
	 */
	triggerEvent(elem, type) {
		let event;
		if (typeof Event === "function") {
			event = new Event(type, {
				bubbles: true,
				cancelable: false
			});
		} else if (document.createEvent) {
			event = document.createEvent("HTMLEvents");
			event.initEvent(type, true, false);
		}
		elem.dispatchEvent(event);
	}
	/**
	 * Fadeout un élément
	 * 
	 * @param {dom} element -> element qui doit fade
	 */
	fadeOut(element) {
		let opacity = 1;
		const duration = 500;
		const interval = 20;
		const steps = duration / interval;
		const delta = opacity / steps;

		// Si un effet de fade est déjà en cours, on le stoppe
		if (this.fadeEffect) {
			clearInterval(this.fadeEffect);
			element.style.opacity = 1;
		}

		setTimeout(() => {
			this.fadeEffect = setInterval(() => {
				opacity -= delta;
				element.style.opacity = opacity;
				if (opacity <= 0) {
					clearInterval(this.fadeEffect);
					element.style.display = "none";
				}
			}, interval);
		}, 8000);
	}
	/**
	 *  Affiche les champs invalides d'un formulaire
	 * 
	 * @param {int} id -> id du fomulaire
	 */
	highlightInvalid(id) {
		const form = document.getElementById(id);

		// Sélection des champs invalides natifs
		const invalidFields = form.querySelectorAll(":invalid");
		invalidFields.forEach((field) => {
			this.isInvalid(field.id);
		});
	}
	/**
	 * Rend un champ invalide
	 * 
	 * @param {int} id -> id de l'élément
	 */
	isInvalid(id) {
		let element = document.getElementById(id);
		if (!element) {
			return;
		}

		// Gestion des cas comme Selectize
		if (id.includes("selectized")) {
			element = element.parentNode;
		}

		// Ajoute la classe d'erreur
		element.classList.add("input_invalid");

		// Supprime les anciens messages d'erreur s’il y en a
		const existingError = element.parentNode.querySelector(".input_invalid_message");
		if (existingError) {
			existingError.remove();
		}

		// Crée la div du message d'erreur
		const errorDiv = document.createElement("div");
		errorDiv.className = "input_invalid_message";
		errorDiv.textContent = "Vérifiez ce champ";

		// Ajoute le message après l'élément
		if (element.nextSibling) {
			element.parentNode.insertBefore(errorDiv, element.nextSibling);
		} else {
			element.parentNode.appendChild(errorDiv);
		}

		// Supprime la classe et le message quand l'utilisateur modifie le champ
		const removeError = () => {
			element.classList.remove("input_invalid");
			if (errorDiv && errorDiv.parentNode) {
				errorDiv.remove();
			}
			element.removeEventListener("input", removeError);
			element.removeEventListener("change", removeError); // pour les select
		};

		element.addEventListener("input", removeError);
		element.addEventListener("change", removeError);
	}
	/**
	 * Décode une chaine HTML
	 * 
	 * @param {obj} input
	 */
	htmlDecode(input) {
		const doc = new DOMParser().parseFromString(input, "text/html");
		return doc.documentElement.textContent;
	}
	/**
	 * Trie un tableau
	 * 
	 * @param {element} table -> tableau
	 */
	sortTable(table) {
		const headers = table.querySelectorAll("th");

		//boucle pour chaque header
		headers.forEach((header, columnIndex) => {

			//double flèche par défaut
			if (header.dataset.sortable) {
				header.classList.add("sortable-default");

				//évènement au click
				header.addEventListener("click", () => {
					const tbody = table.querySelector("tbody");
					const rows = Array.from(tbody.children);
					const sortableType = header.dataset.sortable;

					//dans quel ordre?
					const sortOrder = (table.dataset.sortBy === columnIndex && table.dataset.sortOrder === "asc") ? "desc" : "asc";

					//trie les colonnes
					rows.sort((a, b) => {
						let cellA = a.children[columnIndex];
						let cellB = b.children[columnIndex];

						//si c'est le tableau des évaluations et la colonne avec le niveau
						if (table.classList.contains("table_evaluation_detail")) {
							if (columnIndex === 2) {
								cellA = a.children[2].querySelector(".temps");
								cellB = b.children[2].querySelector(".temps");
							} else if (columnIndex === 3) {
								cellA = a.children[3].querySelector(".progression_texte");
								cellB = b.children[3].querySelector(".progression_texte");
							}
						}

						//clean le contenu
						cellA = cellA.innerText.replace(/[\r\n]+/g, " ").trim().replace(/ +(?= )/g, "");
						cellB = cellB.innerText.replace(/[\r\n]+/g, " ").trim().replace(/ +(?= )/g, "");

						//tri en fonction du sortableType
						let comparison;
						if (sortableType === "date") {
							const dateA = this.parseCustomDate(cellA);
							const dateB = this.parseCustomDate(cellB);
							comparison = dateA - dateB;
						} else if (sortableType === "text" && /^\d/.test(cellA) && /^\d/.test(cellB)) {
							// Sort by number if both cells start with a number
							const numberA = parseFloat(cellA.replace(",", ".").replace(" ", "").match(/^\d+/)[0]);
							const numberB = parseFloat(cellB.replace(",", ".").replace(" ", "").match(/^\d+/)[0]);
							comparison = numberA - numberB;
						} else {
							// Handle default text column sorting
							comparison = cellA.localeCompare(cellB);
						}

						return sortOrder === "asc" ? comparison : -comparison;
					});
					rows.forEach(row => tbody.appendChild(row));

					//met à jour les headers du tableau
					headers.forEach(header => {
						if (header.dataset.sortable) {
							header.classList.remove("asc", "desc");
							header.classList.add("sortable-default");
						}
					});

					//met à jour la colonne cliquée
					header.classList.remove("sortable-default");
					header.classList.add(sortOrder);

					//enregistre les infos de tri
					table.dataset.sortBy = columnIndex;
					table.dataset.sortOrder = sortOrder;
				});
			}
		});
	}
	/**
	 * Parse une date passée
	 * 
	 * @param {string} dateString
	 */
	parseCustomDate(dateString) {
		const [datePart, timePart] = dateString.split(" ");
		const [day, month, year] = datePart.split("/");
		let hour = 0;
		let minutes = 0;
		if (timePart && !timePart.includes("(")) {
			[hour, minutes] = timePart.split(":");
		}
		const customDate = new Date(year, month - 1, day, hour, minutes);
		return customDate;
	}
	/**
	 * Initialise les titlepanes
	 */
	initTitlePanes() {
		document.addEventListener("click", (e) => {
			const accordionTitle = e.target.closest(".accordion-title");
			if (!accordionTitle) {
				return;
			}

			const titlePane = $(accordionTitle).closest(".accordion");
			const opened = titlePane.hasClass("open");

			// Ferme tous les accordion-content et retire la classe 'open' de tous les accordion
			$(".accordion-content").slideUp();
			$(".accordion").removeClass("open");

			// Ouvre uniquement le accordion-content associé au accordion-title cliqué
			if (!opened) {
				titlePane.addClass("open");
				titlePane.find(".accordion-content").slideDown();
			}
		});
	}
	/**
	 * Ouvre la prochaine étape
	 * 
	 * @param {string} id_close -> id du pane à fermer
	 * @param {string} id_open -> id du pane à ouvrir
	 */
	titlePaneSlide(id_close, id_open) {

		//s'il faut fermer un pane
		if (id_close !== null) {
			if (document.getElementById(id_close + "_form_errors")) {
				document.getElementById(id_close + "_form_errors").innerHTML = "";
				document.getElementById("valide_etape_" + id_close).style.visibility = "visible";
			}
			$("#accordion_" + id_close).removeClass("open");
			$("#accordion_" + id_close).find(".accordion-content").slideUp();
		}

		//s'il faut ouvrir un pane
		if (id_open !== null) {
			this.setDisplay("accordion_" + id_open, "block");
			if (document.getElementById("warning_etape_" + id_open)) {
				this.setDisplay("warning_etape_" + id_open, "none");
				this.setDisplay(id_open + "_all", "block");
			}
			if (!$("#accordion_" + id_open).hasClass("open")) {
				$("#accordion_" + id_open).addClass("open");
				$("#accordion_" + id_open).find(".accordion-content").slideDown();
			}
		}
	}
	/**
	 * Récupère les communes
	 * 
	 * @param {bool} disabled -> true, false
	 * @param {int} id_commune -> valeur
	 */
	getCommunes(disabled, id_commune = null) {
		const self = this;
		return new Promise(function (resolve) {

			//récupère la liste des communes
			const select_commune = $("#commune_etablissement").selectize({
				plugins: ["restore_on_backspace"],
				persist: false,
				maxItems: 1,
				valueField: "id",
				labelField: "commune",
				searchField: ["commune", "code_postal"],
				load: (query, callback) => {

					//si la recherche est vide
					if (!query.length) {
						return callback();
					}

					//récupère les mots qui correspondent
					$.getJSON(php_to_js_vars.url + "api/store/communes", {search: query}, (res) => {
						callback(res);
					}).fail(() => {
						callback();
					});
				},
				render: {
					item: (item, escape) => {
						return "<div>" + escape(item.code_postal) + " - " + escape(item.commune) + "</div>";
					},
					option: (item, escape) => {
						return "<div>" + escape(item.code_postal) + " - " + escape(item.commune) + "</div>";
					}
				}
			});

			//s'il faut sélectionner une valeur par défaut
			if (id_commune !== null) {
				self.updateCommunes(id_commune);
			}

			//disable?
			if (disabled === true) {
				select_commune[0].selectize.disable();
			}

			//feedback
			resolve();
		});
	}
	/**
	 * Récupère les communes
	 * 
	 * @param {int} id_commune -> valeur
	 */
	updateCommunes(id_commune = null) {
		const select_commune = $("#commune_etablissement").selectize()[0].selectize;
		select_commune.load((callback) => {
			$.getJSON(php_to_js_vars.url + "api/store/communes", {search: id_commune}, (res) => {
				callback(res);

				//vérifie que la commune existe dans le store
				if (res.some(item => item.id === id_commune)) {
					select_commune.setValue(id_commune);
				}
			}).fail(() => {
				callback();
			});
		});
	}
	/**
	 * Récupère les pays
	 * 
	 * @param {bool} disabled -> true, false
	 * @param {int} id_pays -> id_pays
	 */
	getPays(disabled, id_pays = null) {
		const self = this;
		return new Promise(function (resolve, reject) {

			//génère le select pays
			$.getJSON(php_to_js_vars.url + "api/store/pays", (data) => {
				let lastValue = null;
				const select_pays = $("#pays_etablissement").selectize({
					plugins: ["restore_on_backspace"],
					delimiter: " - ",
					persist: false,
					maxItems: 1,
					valueField: "id",
					labelField: "nom",
					searchField: ["nom"],
					options: data,
					onChange: function (value) {
						const newValue = value ? String(value) : "";
						const prevValue = lastValue === null ? "" : String(lastValue);

						// si pas de value, on fait rien
						if (!newValue) {
							lastValue = newValue;
							return;
						}

						// seulement si la valeur a vraiment changé
						if (newValue !== prevValue) {
							self.updateOrganismeForm();
						}

						lastValue = newValue;

						//grise uniquement la commune courante
						const control = this;
						setTimeout(function () {
							const currentValue = control.getValue();
							control.$dropdown.find('.option').removeClass('selected active');
							if (currentValue) {
								control.$dropdown.find('.option[data-value="' + currentValue + '"]').addClass('selected');
							}
						}, 0);
					}
				});

				//si aucune valeur par défaut est fournie
				if (!id_pays) {
					//on récupère la France
					const def = data.find(p => p.is_default === "1");
					if (def) {
						id_pays = def.id;
					}
				}

				//select de la valeur
				select_pays[0].selectize.setValue(id_pays);

				//disable?
				if (disabled === true) {
					select_pays[0].selectize.disable();
				}

				//feedback
				resolve();
			}).fail((error) => {
				reject(error);
			});
		});
	}
	/**
	 * Met à jour le formulaire avec l'organisme
	 */
	updateOrganismeForm() {

		//récupère le type établissement
		let typeEtab = null;
		if (document.getElementById("type_etablissement") && document.getElementById("type_etablissement").value) {
			typeEtab = document.getElementById("type_etablissement").value;
		}
		$.getJSON(php_to_js_vars.url + "commande/etablissementType/" + typeEtab, (data) => {
			let askSiret = false;
			let askTvaIntra = false;

			//récupère le pays sélectioné
			const select = $("#pays_etablissement")[0].selectize;
			const value = select.getValue();
			if (value) {
				const item = select.options[value];

				//met à jour la tva
				this.currentTva = parseFloat(item.tva);

				//désactive / active le champ commune en fonction du formulaire
				if (document.getElementById("commune_etablissement") && (!document.getElementById("code_uai") || document.getElementById("etablissement_sans_uai").checked === true)) {
					const select_commune = $("#commune_etablissement").selectize()[0].selectize;
					if (item.has_code_postal === "true") {
						select_commune.enable();
						if (select_commune.getValue() === "99999") {
							select_commune.clear();
						}
					} else {
						select_commune.disable();
						this.updateCommunes("99999");
					}
				}

				//si aucun retour
				if ($.isEmptyObject(data) && item.is_default === "1") {
					
					//si formulaire sans code uai
					if (!document.getElementById("code_uai") || document.getElementById("etablissement_sans_uai").checked === true) {
						askSiret = true;
					}
				} else {

					//si c'est la France, et que le type demande un siret
					if (item.is_default === "1" && data.ask_siret === "yes" && data.type !== "Mairie" && data.type !== "Communauté de communes") {

						//s'il n'y a pas de code uai
						if (!document.getElementById("code_uai") || document.getElementById("etablissement_sans_uai").checked === true) {
							askSiret = true;
						}
					}
				}

				//s'il faut demander la tva intra
				if (item.is_default === "0" && item.ue == "1" && (!document.getElementById("code_uai") || document.getElementById("etablissement_sans_uai").checked === true)) {
					askTvaIntra = true;
				}
			}

			//affiche / cache le siret
			if (document.getElementById("siret")) {
				if (askSiret == false) {
					this.setDisplay("td_siret", "none");
					document.getElementById("siret").required = false;
				} else {
					this.setDisplay("td_siret", "block");
					document.getElementById("siret").required = true;
				}
			}

			//affiche / cache la tva intra
			if (document.getElementById("td_tva_intra")) {
				if (askTvaIntra == false) {
					this.setDisplay("td_tva_intra", "none");
				} else {
					this.setDisplay("td_tva_intra", "block");
				}
			}

			//s'il faut recalculer le prix
			if (document.getElementById("nb_licences")) {
				this.updatePrix();
			}
		});

		//s'il y a le choix avec / sans uai
		if (document.getElementById("etablissement_avec_uai")) {

			//si c'est code uai qui est coché
			if (document.getElementById("etablissement_avec_uai").checked === true) {

				//affiche le champ code_uai
				this.setDisplay("div_code_uai", "flex");
				document.getElementById("code_uai").required = true;

				//récupère l'établissement
				this.getEtablissement();
			} else if (document.getElementById("etablissement_sans_uai").checked === true) {

				//active les champs
				this.setDisabled("type_etablissement", false);
				this.setDisabled("nom_etablissement", false);
				this.setDisabled("adresse_etablissement", false);
				$("#commune_etablissement").selectize()[0].selectize.enable();
				$("#pays_etablissement").selectize()[0].selectize.enable();

				//cache le champ code uai
				this.setDisplay("div_code_uai", "none");
				document.getElementById("code_uai").required = false;
			}
		}
	}
	/**
	 * Récupère un établissement
	 */
	getEtablissement() {
		const select_commune = $("#commune_etablissement").selectize()[0].selectize;
		const select_pays = $("#pays_etablissement").selectize()[0].selectize;

		//s'il y a un code uai fourni
		if (document.getElementById("code_uai") && document.getElementById("code_uai").value !== "" && document.getElementById("code_uai").checkValidity()) {

			//recupère les infos de l'établissement
			$.ajax({
				type: "POST",
				url: php_to_js_vars.url + "inscription/etablissementData",
				data: {
					"code_uai": document.getElementById("code_uai").value
				},
				dataType: "json"
			}).done((data) => {

				//s'il y a une réponse
				if (data.etablissement !== "") {

					//valeur des champs
					document.getElementById("type_etablissement").value = data.etablissement.id_type;
					document.getElementById("nom_etablissement").value = data.etablissement.nom;
					document.getElementById("adresse_etablissement").value = data.etablissement.adresse;
					this.updateCommunes(data.etablissement.id_commune);
					const select_pays = $("#pays_etablissement").selectize()[0].selectize;
					select_pays.setValue(data.etablissement.id_pays);

					//page avec les champs cachés
					if (document.getElementById("form_errors_etablissement")) {
						this.setDisplay("form_errors_etablissement", "none");
						document.querySelectorAll(".infos_etablissement").forEach(element => {
							element.style.display = "block";
						});
					} else {

						//désactive les champs
						this.setDisabled("type_etablissement", true);
						this.setDisabled("nom_etablissement", true);
						this.setDisabled("adresse_etablissement", true);
						select_commune.disable();
						select_pays.disable();
					}
				} else {

					//vide les champs
					document.getElementById("type_etablissement").value = "";
					document.getElementById("nom_etablissement").value = "";
					document.getElementById("adresse_etablissement").value = "";
					select_commune.clear();

					//page avec les champs cachés
					if (document.getElementById("form_errors_etablissement")) {
						this.showFormError("form_errors_etablissement", "Il n'y a aucun établissement avec ce code UAI.");
					} else {

						//réactive les champs
						this.setDisabled("type_etablissement", false);
						this.setDisabled("nom_etablissement", false);
						this.setDisabled("adresse_etablissement", false);
						select_commune.enable();
						select_pays.enable();
					}
				}
			});
		} else {
			//vide les champs
			document.getElementById("type_etablissement").value = "";
			document.getElementById("nom_etablissement").value = "";
			document.getElementById("adresse_etablissement").value = "";
			select_commune.clear();

			//page avec les champs cachés
			if (document.getElementById("form_errors_etablissement")) {

				//cache les champs
				this.setDisplay("form_errors_etablissement", "none");
				document.querySelectorAll(".infos_etablissement").forEach(element => {
					element.style.display = "none";
				});
			}
		}
	}
	/**
	 * Verifie le justificatif
	 * 
	 * @param {string} form_errors -> id du form_errors
	 */
	checkJustificatif(form_errors) {

		//vérifie qu'il y a bien un fichier
		if (document.getElementById("fichier_justificatif").value === "") {
			this.showFormError(form_errors, "Vous n'avez pas fourni de fichier.");
		} else {

			//envoie le fichier
			$.ajax({
				url: php_to_js_vars.url + "inscription/checkJustificatif",
				type: "POST",
				data: new FormData(document.getElementById("form_justificatif")),
				dataType: "json",
				processData: false,
				contentType: false
			}).done((data) => {

				// Créer un objet pour les messages d'erreur
				const errorMessages = {
					"": "Problème lors de l'importation du fichier. Veuillez recommencer.",
					"filesize": "Le fichier choisi est trop volumineux.",
					"filetype": "Ce type de fichier n'est pas pris en charge."
				};

				// Vérifier si le message d'erreur existe dans l'objet
				if (errorMessages[data.message]) {
					this.showFormError(form_errors, errorMessages[data.message]);
					document.getElementById("fichier_justificatif").value = "";
				} else {
					this.setDisplay(form_errors, "none");
					document.getElementById("lien_justificatif").value = data.message;
				}
			}).fail(() => {

				//relance la fonction (bug incompréhensible)
				this.checkJustificatif(form_errors);
			});
		}
	}
	/**
	 * Met à jour les prix ht et ttc en fonction du nombre de licences
	 */
	updatePrix() {

		//calcul du coefficient de conversion
		const coeff = (100 + this.currentTva) / 100;

		//calcul du montant ht
		const input_nb_licences = document.getElementById("nb_licences");
		const prix_licence = input_nb_licences.dataset.prixLicence;
		let montant_ht = prix_licence * input_nb_licences.value;

		//calcul du montant ttc
		let montant_ttc = montant_ht * coeff;

		//arrondi les montants
		montant_ht = montant_ht.toFixed(2);
		montant_ttc = montant_ttc.toFixed(2);

		//affiche le prix dans le formulaire
		document.getElementById("montant_ht").innerHTML = montant_ht.toString().replace(".", ",");
		document.getElementById("montant_ttc").innerHTML = montant_ttc.toString().replace(".", ",");
	}
	/**
	 * Affiche le dialog des auteurs
	 * 
	 * @param {int} id_module -> id du module
	 */
	showAuteurs(id_module) {
		$.getJSON(php_to_js_vars.url + "utilisateur/auteurs/" + id_module, (data) => {

			//id du dialog
			const id_dialog = "dialog_auteurs";
			this.objDialog.setId(id_dialog);

			//si le dialog n'existe pas
			if (!document.getElementById(id_dialog)) {

				//création du dialog
				this.objDialog.create("Liste des auteurs", false);

				//message d'alerte
				const div = document.createElement("div");
				div.id = "dialog_auteurs_content";
				this.objDialog.updateContent(div);
			}

			//numéro du bordereau
			document.getElementById("dialog_auteurs_content").innerHTML = data.auteurs;

			//ouvre le dialog
			this.objDialog.show();
		});
	}
	/**
	 * Switch les onglets
	 * 
	 * @param {string} onglet -> onglet sélectionné
	 */
	switchOnglet(onglet) {

		//sélectionne l'onglet
		document.querySelectorAll(".onglet_selected").forEach(element => {
			element.className = "onglet";
		});
		document.getElementById(onglet).className = "onglet_selected";

		//affcihe le contenu
		document.querySelectorAll(".contenu_onglet").forEach(element => {
			element.style.display = "none";
		});
		this.setDisplay("onglet_" + onglet, "");
	}
}
